import { Resource } from './resource';
import { InterviewStatus } from './interviewStatus';

export class InterviewFeedback extends Resource {
 interviewId :string;
    interviewStepMappingId :string;
    interviewerId :string;
   feedback :string;
   interviewStatus :string;
   interviewStepStatus :string;
  }